import { ActionType } from "../../../../../../../../react-core/Flux/ActionType";
import { BaseStore } from "../../../../../../../../react-core/Flux/BaseStore";
import { ProductCharge } from "../../../../../../../../Wrap/Models/Domains/ProductOverview/Charges/ProductCharge";
import { ProductOverviewChargeDispatcher } from "./Variable";

export interface ProductOverviewChargeStaticState {
    isLoading?: boolean;
    actionType: ActionType;
    data?: ProductCharge;
}

export class ProductOverviewChargeStatic extends BaseStore<ProductOverviewChargeStaticState> {
    constructor() {
        super();
        this.subscribeToDispatcher(ProductOverviewChargeDispatcher, (actionData) =>
            this.onProductOverviewChargeStoreResponse(actionData)
        );
    }

    public getLastResult(): ProductOverviewChargeStaticState {
        return this.getState();
    }

    public isLoading(): boolean {
        return this.getState().isLoading;
    }

    public getData() {
        return this.getState().data;
    }

    public getActionType() {
        return this.getState().actionType;
    }

    protected getDefaultState(): ProductOverviewChargeStaticState {
        return {
            actionType: ActionType.Loading,
            data: null,
            isLoading: false,
        };
    }

    private onProductOverviewChargeStoreResponse(actionData): void {
        switch (actionData.actionType) {
            case ActionType.Success:
                this.setState({ actionType: ActionType.Success, data: actionData.payload });
                break;
            case ActionType.Update:
                this.setState({ actionType: ActionType.Update, data: actionData.payload });
                break;
            case ActionType.Error:
                this.setState({ actionType: ActionType.Error });
                break;
            case ActionType.Loading:
                this.setState({ isLoading: actionData.payload, actionType: ActionType.Loading });
                break;
        }
    }
}
